import { isEqual as _isEqual } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { map, pairwise } from 'rxjs/operators';

import UserAgent from '../helpers/userAgent';

const userAgent = new UserAgent();

export const STORE_KEYS = {
  USER_INFO: 'userInfo',
  WAITING_FOR_FIRST_AUTH: 'waitingForFirstAuth',
  OS_NAME: 'osName',
  BROWSER_NAME: 'browserName',
  BROWSER_VERSION: 'browserVersion',
  DEVICE_TYPE: 'deviceType',
  FINISHED_ONBOARDING: 'finishedOnboarding',
  ADMIN_ACTING_AS: 'adminActingAs',
  IS_TOUCH: 'isTouch',
  ZONES_ENABLED: 'zonesEnabled',
  LOBBIES_ENABLED: 'lobbiesEnabled',
};
class Store {
  store;

  constructor() {
    this.store = new BehaviorSubject({
      [STORE_KEYS.USER_INFO]: {
        photoURL: null,
      },
      [STORE_KEYS.WAITING_FOR_FIRST_AUTH]: true,
      [STORE_KEYS.OS_NAME]: userAgent.getOSName(),
      [STORE_KEYS.BROWSER_NAME]: userAgent.getBrowserName(),
      [STORE_KEYS.BROWSER_VERSION]: userAgent.getBrowserVersion(),
      [STORE_KEYS.DEVICE_TYPE]: userAgent.getDeviceType(),
      [STORE_KEYS.ADMIN_ACTING_AS]: false,
      [STORE_KEYS.IS_TOUCH]: userAgent.isTouch(),
    });
  }

  _selectDataFromStore(selector) {
    return this.store.asObservable().pipe(map(selector), pairwise());
  }

  updateState(data) {
    const state = { ...this.store.value, ...data };
    this.store.next(state);
  }

  getState() {
    return this.store.value;
  }

  setState(state) {
    this.store.next(state);
  }

  subscribe(key, callback) {
    return this._selectDataFromStore((state) => state[key]).subscribe(([previousValue, currentValue]) => {
      if (!_isEqual(currentValue, previousValue)) {
        callback(currentValue);
      }
    });
  }
}

export const store = new Store();
